import app from 'firebase/compat/app';
import 'firebase/compat/firestore';
import "firebase/compat/auth";
import { disableNetwork } from "firebase/firestore";
import { enableNetwork } from "firebase/firestore";
import { configFirebase, configFirebaseSecondary } from 'AppPersonalise';



class FirebaseUtil {
	constructor() {
		this.networkDisabled = false;
		app.initializeApp(configFirebase)
		this.currentUser = null;
		this.auth = app.auth()

		this.db = app.firestore()


		this.db.settings({
			cacheSizeBytes: app.firestore.CACHE_SIZE_UNLIMITED
		});


		this.db.enablePersistence({ synchronizeTabs: true }).catch(function (err) {
			console.log("Erro ao ativar persistencia offline: ", err);
			if (err.code === 'failed-precondition') {
				// Multiple tabs open, persistence can only be enabled
				// in one tab at a a time.
				// ...
			} else if (err.code === 'unimplemented') {
				// The current browser does not support all of the
				// features required to enable persistence
				// ...
			}
		});
		if (window.cordova) {
			//this.disableNetwork()
		}

	}

	firestore() {
		return app.firestore
	}

	disableNetwork() {
		disableNetwork(this.db).then(() => {
			console.log("Network disabled!");
			this.networkDisabled = true;
		});

	}
	enableNetwork() {

		enableNetwork(this.db).then(() => {
			console.log("Network enabled!");
			this.networkDisabled = false;
		});
	}

	login(email, password) {
		return this.auth.signInWithEmailAndPassword(email, password)
	}


	logout() {
		this.currentUser = null;
		return this.auth.signOut()
	}

	async registerNoLogin(email, password) {
		return new Promise((resolve, reject) => {
			let secondaryApp = app.initializeApp(configFirebaseSecondary, "Secondary")

			secondaryApp.auth().createUserWithEmailAndPassword(email, password).then(
				(firebaseUser) => {
					// console.log('firebaseUser', firebaseUser)
					console.log("User created successfully!" /*+ firebaseUser.user.uid*/);
					secondaryApp.auth().signOut();
					resolve(firebaseUser)
				}).catch(error => {
					reject(error)
				})
		})
		// return this.getCurrentUser().updateProfile({ displayName: name })
	}

	async register(name, email, password) {
		await this.auth.createUserWithEmailAndPassword(email, password)
		return this.getCurrentUser().updateProfile({
			displayName: name
		})
	}

	isInitialized(updateUser) {
		return new Promise(resolve => {
			this.auth.onAuthStateChanged((r) => {
				this.currentUser = r;
				// console.log('logado onAuthStateChanged', r)
				if (updateUser) updateUser(r)
				resolve(r);
			})
		})
	}

	getCurrentUsername() {
		return this.getCurrentUser() && this.getCurrentUser().displayName
	}
	getCurrentUser() {
		if (this.currentUser) {
			return this.currentUser;
		}
		return this.auth.currentUser
	}
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new FirebaseUtil()